import { v4 as uuidv4 } from 'uuid';

const DesiList = [
  {
    name: "Veg Shammi Kebab",
    price: [300, 590],
    type: "starter",
    isVeg: true,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Crispy Corn",
    price: [120],
    type: "starter",
    isVeg: true,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Angara Chicken Tikka",
    price: [220],
    type: "starter",
    isVeg: false,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Sweet Spicy Wings",
    price: [180],
    type: "starter",
    isVeg: false,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Garlic N Chicken Seekh",
    price: [80],
    type: "starter",
    isVeg: false,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Kasundi Fish Tikka",
    price: [120],
    type: "starter",
    isVeg: false,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Chilli Garlic Prawns",
    price: [220],
    type: "starter",
    isVeg: false,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Kurkuri Bhindi masala",
    price: [200, 390],
    isVeg: true,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Panner E Lazeez",
    price: [300, 590],
    isVeg: true,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Chatpata Jeera Aloo",
    price: [150, 290],
    isVeg: true,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Malai Kofta Curry",
    price: [300, 590],
    isVeg: true,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Butter Chicken",
    price: [350, 690],
    isVeg: false,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Mutton Rogani",
    price: [350, 690],
    isVeg: false,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Egg Masala",
    price: [200, 390],
    isVeg: false,
    type: "main course",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Kesari Phirnee",
    price: [200],
    isVeg: true,
    type: "dessert",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Gulab Jamun",
    price: [200],
    isVeg: true,
    type: "dessert",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Shahi Tukda",
    price: [150],
    isVeg: true,
    type: "dessert",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Mango Mousse",
    price: [150],
    isVeg: true,
    type: "dessert",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Plain Rice",
    price: [150, 290],
    isVeg: true,
    type: "rice",
    rated: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Jeera Rice",
    price: [190, 370],
    isVeg: true,
    type: "rice",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "BEETROOT N CARROT SALAD",
    price: [190],
    isVeg: true,
    type: "salad",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "GARDEN GREEN SALAD",
    price: [160],
    isVeg: true,
    type: "salad",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "BEANS SPROUT SALAD",
    price: [200],
    isVeg: true,
    type: "salad",
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
  {
    name: "Tandoori  Paneer  Tikka",
    price: [200, 390],
    type: "starter",
    isVeg: true,
    rating: 4.5,
    imgpath: '../../img/desi/',
    id: uuidv4(),
  },
]

export default  DesiList;